/** Public site-specific Plausible installation; no analytics environment variables. */
export const plausibleConfig = {
  domain: 'wan22.io',
  script: 'https://stat.re/js/pa-JOe9IY-fBdErS4Rbavr42.js',
};
